// prop-types is a library for typechecking of props

// @mui material components
import Card from "@mui/material/Card"
import Grid from "@mui/material/Grid"
import Icon from "@mui/material/Icon"

// Soft UI Dashboard React components
import SoftBox from "soft_dashboard/components/SoftBox"
import SoftTypography from "soft_dashboard/components/SoftTypography"
import { numberWithCommas } from "../../Util/Util"

function MiniStatsCard({
  bgColor,
  title,
  count,
  percentage,
  icon,
  prefix,
}) {
  let percentageColor = "success"
  if (percentage?.startsWith("-")) {
    percentageColor = "error"
  }

  return (
    <Card>
      <SoftBox sx={{ backgroundColor: "#152737" }}>
        <SoftBox p={2}>
          <SoftBox lineHeight={1}>
            <SoftTypography
              variant="button"
              color="text"
              opacity={0.8}
              textTransform="capitalize"
              sx={{ fontSize: { xs: "0.65rem", sm: "0.75rem" } }}
            >
              {title}
            </SoftTypography>
            <SoftTypography
              variant="h5"
              fontWeight="bold"
              color="dark"
              sx={{ fontSize: { xs: "1rem", sm: "1.25rem" }, whiteSpace: "nowrap" }}
            >
              {prefix}
              {numberWithCommas(count)}{" "}
              {percentage && (
                <SoftTypography
                  variant="button"
                  color={percentageColor}
                  fontWeight="bold"
                  sx={{ fontSize: { xs: "0.65rem", sm: "0.75rem" } }}
                >
                  {percentage}
                </SoftTypography>
              )}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </Card>
  )
}

export default MiniStatsCard
